import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';

import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    public router: Router,
    public matSnackBar: MatSnackBar
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['login']);
      return false;
    }

    const hasMedicalRole = this.auth.hasRole('Doctor') || this.auth.hasRole('Demographic') || this.auth.hasRole('Dispensary');

    // Si tiene rol médico (Doctor, Demographic o Dispensary ), permitir acceso
    if (hasMedicalRole) {
      return true;
    }

    // Si es técnico interno, permitir acceso
    if (this.auth.hasRole('tecnico interno')) {
      return true;
    }

    // Si es proponente sin rol médico, redirigir a transactions
    if (this.auth.hasRole('Proponente')) {
      this.router.navigate(['/transactions']);
      return false;
    }

    // Si no tiene ninguno de los roles permitidos, logout
    this.matSnackBar.open('Hubo un problema con el usuario', 'OK', {
      duration: 3000
    });
    this.auth.logout();
    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    return this.canActivate(route, state);
  }
}
